import { render, staticRenderFns } from "./requestInvoice.vue?vue&type=template&id=644d6d59&scoped=true"
import script from "./requestInvoice.vue?vue&type=script&lang=js"
export * from "./requestInvoice.vue?vue&type=script&lang=js"
import style0 from "./requestInvoice.vue?vue&type=style&index=0&id=644d6d59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d6d59",
  null
  
)

export default component.exports